import React from "react";

const Status = ({ type }) => {
  if (type === "submitted") {
    return (
      <div>
        <b>BACKTEST : SUBMITTED </b>
        <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }}></i>
      </div>
    );
  } else if (type === "processing") {
    return (
      <div>
        <b>BACKTEST : PROCESSING</b>
      </div>
    );
  } else if (type === "error") {
    return (
      <div>
        <b>BACKTEST : ERROR</b>
      </div>
    );
  }
};

export default Status;



// WEBPACK FOOTER //
// ./src/components/myPortfolios/cards/helper/Status.jsx